import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const eventTracking = {
  eventStack: {},
  origin: ""
};

export const eventTrackSlice = createSlice({
  name: "eventTrack",
  initialState: eventTracking,
  reducers: {
    addingNewEvent: (state, action) => {
      const tempState = JSON.parse(JSON.stringify(state.eventStack));
      const { payload } = action;

      if (tempState[payload.eventName]) {
        const arrivalDiff = moment(tempState[payload.eventName].arrivalDateInState).diff(
          moment(payload.arrivalDateInState)
        );
        const departualDiff = moment(tempState[payload.eventName].departureDateInState).diff(
          moment(payload.departureDateInState)
        );
        if (
          tempState[payload.eventName].origin == payload.origin &&
          tempState[payload.eventName].destination == payload.destination &&
          tempState[payload.eventName].tripType == payload.tripType &&
          tempState[payload.eventName].passenger?.total == payload.passenger?.total &&
          arrivalDiff == 0 &&
          departualDiff == 0
        ) {
          // dont put in list
        } else {
          // put that event into the list
          tempState[payload.eventName] = {
            origin: payload.origin,
            destination: payload.destination,
            tripType: payload.tripType,
            arrivalDateInState: moment(payload.arrivalDateInState).format("DD-MM-YYYY HH:MM").toString(),
            departureDateInState: moment(payload.departureDateInState).format("DD-MM-YYYY HH:MM").toString(),
            passenger: payload.passenger
          };
        }
      } else {
        tempState[payload.eventName] = {
          origin: payload.origin,
          destination: payload.destination,
          tripType: payload.tripType,
          arrivalDateInState: moment(payload.arrivalDateInState).format("DD-MM-YYYY HH:MM").toString(),
          departureDateInState: moment(payload.departureDateInState).format("DD-MM-YYYY HH:MM").toString(),
          passenger: payload.passenger
        };
      }
      state.eventStack = tempState;
    },
    setOriginForEventTrack: (state, action) => {
      const tempState = JSON.parse(JSON.stringify(state.eventStack));
      tempState.origin = action.payload.origin;
      state.eventStack = tempState;
    }
  }
});

export const { addingNewEvent, setOriginForEventTrack } = eventTrackSlice.actions;

export default eventTrackSlice.reducer;
